import { useEffect, useMemo } from "react";

import { useLocation } from "react-router-dom";
import useSWR from "swr";

import { SERIES_ROOT } from "src/constants";
import useSlug from "src/redux/hooks/useSlug";
import { SWR_PORTAL_ITEM_KEY } from "src/services/swr_keys";
import { SERVICE_1, callLambda } from "src/utils/lambda";

const SERIES_ROOT_PATHS = [...new Set(Object.values(SERIES_ROOT))];

export default () => {
  const location = useLocation();
  const { setData: setSlug } = useSlug();
  const slug = useMemo(() => {
    if (!SERIES_ROOT_PATHS.some(dir => location.pathname.startsWith(dir))) {
      return null;
    }
    return location.pathname.split("/")[2];
  }, [location]);

  useEffect(() => {
    setSlug(slug);
  }, [slug, setSlug]);

  return useSWR(
    SWR_PORTAL_ITEM_KEY(slug),
    () => (slug ? callLambda({
      method   : "get",
      service  : SERVICE_1,
      url      : "getPortalInfo",
      unauthed : true
    }) : null)
  );
};
